import { toast, ToastOptions, ToastContent } from 'react-toastify'

const commonOptions = (text: ToastContent, options?: ToastOptions): ToastOptions => {
  return {
    autoClose: 1200,
    closeButton: false,
    hideProgressBar: true,
    position: 'bottom-center',
    ...options,
  }
}

export const successToast = (text: ToastContent, options?: ToastOptions) =>
  toast.success(text, commonOptions(text, options))

export const defaultToast = (text: ToastContent, options?: ToastOptions) =>
  toast(text, commonOptions(text, options))

export const infoToast = (text: ToastContent, options?: ToastOptions) =>
  toast.info(text, commonOptions(text, options))

export const errorToast = (text: ToastContent, options?: ToastOptions) =>
  toast.error(text, commonOptions(text, options))

export const warnToast = (text: ToastContent, options?: ToastOptions) =>
  toast.warn(text, commonOptions(text, options))
